import React from 'react'

import TextToTextTransformerLayout from '../../../components/layouts/TextToTextTransformerLayout'


export default function CodeMinifierLayout({lang, minify}) {
  return (
    <TextToTextTransformerLayout
      inputLang={lang}
      outputLang={lang}
      transform={minify}
    />
  )
}
